import React from 'react';
import { NavLink } from 'react-router-dom';

import imgHallChadwickLogo from '../images/powered-by-hall-chadwick-forensics.png';
import imgXpediteLogo from '../images/xpedite-logo.png';

const blank = (props) => (
	<div className='page'>

		<section className='page__section page__section--white'>

			<div className='wrapper wrapper--narrow clearfix'>

				<div className='page__header__logo page__header__logo--left pull-left--medium'>
					<h1 className='page__heading'>
						<a href='http://hallchadwickmelb.com.au/' rel='noopener noreferrer' target='_blank'>
							<img src={imgHallChadwickLogo} alt='powered by Hall Chadwick Forensics' />
						</a>
					</h1>
				</div>

				<div className='page__header__logo page__section__w30 page__header__logo--right pull-right--medium'>
					<h2 className='page__heading'>
						<NavLink to='/'>
							<img src={imgXpediteLogo} alt='Xpedite' />
						</NavLink>
					</h2>
				</div>

			</div>

		</section>

		<section className='page__section page__section--white'>

			<div className='wrapper wrapper--narrow clearfix'>

				<div className='page__content'>

					<h3 className='page__content__heading'>Sorry, that page doesn't exist</h3>

					<p><strong>{window.location.pathname}</strong></p>

					<p>You have tried to reach, or been directed to, a page that doesn't exist in <strong>Xpedite</strong>. Try returning to the home page and use the navigation from there to get to the page you are after.</p>

					<p><NavLink to='/' className='btn btn--stubby'>Return home</NavLink></p>

				</div>

			</div>

		</section>

	</div>
);


export default blank;


// WEBPACK FOOTER //
// ./src/Pages/Blank.js